'use client';

interface ProductFiltersProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
}

export default function ProductFilters({
  categories,
  selectedCategory,
  onCategoryChange,
  sortBy,
  onSortChange
}: ProductFiltersProps) {
  return (
    <div className="lg:w-80 space-y-6">
      <div className="bg-white rounded-2xl shadow-lg p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Categories</h3>
        <div className="space-y-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
                selectedCategory === category
                  ? 'bg-green-600 text-white'
                  : 'hover:bg-green-50 text-gray-700'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Sort By</h3>
        <div className="space-y-2">
          <button
            onClick={() => onSortChange('featured')}
            className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
              sortBy === 'featured'
                ? 'bg-green-600 text-white'
                : 'hover:bg-green-50 text-gray-700'
            }`}
          >
            Featured
          </button>
          <button
            onClick={() => onSortChange('price-low')}
            className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
              sortBy === 'price-low'
                ? 'bg-green-600 text-white'
                : 'hover:bg-green-50 text-gray-700'
            }`}
          >
            Price: Low to High
          </button>
          <button
            onClick={() => onSortChange('price-high')}
            className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
              sortBy === 'price-high'
                ? 'bg-green-600 text-white'
                : 'hover:bg-green-50 text-gray-700'
            }`}
          >
            Price: High to Low
          </button>
          <button
            onClick={() => onSortChange('rating')}
            className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
              sortBy === 'rating'
                ? 'bg-green-600 text-white'
                : 'hover:bg-green-50 text-gray-700'
            }`}
          >
            Highest Rated
          </button>
        </div>
      </div>

    </div>
  );
}